import React, { useEffect, useState } from "react";
import { Badge, Button, Spinner } from "reactstrap";
import { useFormData } from "./FormDataContext"; // Import your context hook
import {
  Collapse as AntCollapse,
  Descriptions,
  Popover,
  Timeline,
  Table,
  List,
  Modal,
  Empty,
} from "antd";
import axios from "axios";
import { ApprovalData, Material } from "./types"; // Import your types
import { nanoid } from "nanoid";
import dayjs from "dayjs";
import { PaperClipOutlined, DownloadOutlined } from "@ant-design/icons";
import budgetApis from "../../../api/master/budget";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import rolesApi from "../../../api/master/roles";
import { formatCurrency } from "../../../utils/Utils";
import { render } from "@testing-library/react";

const { Panel } = AntCollapse;

const BudgetPreview: React.FC<{ prev: () => void }> = (props) => {
  const navigate = useNavigate();
  const [disableSubmit, setDisableSubmit] = useState(false);
  const { formData } = useFormData();
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [roles, setRoles] = useState<any>([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);
  const fetchApprovalHierarchyUsersByModuleId = async (moduleID: number) => {
    console.log("formData.site", formData.budgetHeader.site);
    try {
      const res = await rolesApi.fetchHierarchyUsersByModuleId(
        moduleID,
        Number(formData.budgetHeader.site)
      );
      if (!res) return;
      const { data, status } = res;
      if (status) {
        setRoles(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchModuleConfig = async () => {
    try {
      const res = await rolesApi.getModuleConfig();
      const moduleID = res?.data?.find(
        (x: any) => x.moduleName == "Budget"
      )?.moduleID;
      console.log(moduleID);
      await fetchApprovalHierarchyUsersByModuleId(moduleID);
    } catch (err) {
      throw err;
    }
  };

  const handleSubmit = async (data: any) => {
    setDisableSubmit(true);
    console.log("data", data, formData);
    let parsedData: any;
    if (formData.budgetHeader?.approvalsData) {
      parsedData = JSON.parse(formData.budgetHeader?.approvalsData);
    }
    const approvalDataArray = parsedData;
    const formattedApprovalData = approvalDataArray.map((item: any) => ({
      roleId: item.roleId,
      level: item.level,
      userId: item.userId,
    }));
    const submissionData = {
      header: {
        // ...formData.budgetHeader,
        // budgetId: nanoid(4),
        orgId: 1,
        status: "PENDING",
        budgetId: formData.budgetHeader?.budgetId || "",
        budgetName: formData.budgetHeader?.budgetName || "",
        startDate: formData.budgetHeader?.startDate || "",
        endDate: formData.budgetHeader?.endDate || "",
        description: formData.budgetHeader?.description || "",
        budgetFor: formData.budgetHeader?.budgetFor || "",
        site: parseInt(formData.budgetHeader?.site) || "",
        contractor: parseInt(formData.budgetHeader?.contractor) || null,
        costCenter:
          formData.budgetHeader?.costCenter !== undefined
            ? parseInt(formData.budgetHeader?.costCenter)
            : null,
        lob: formData.budgetHeader?.lob || "",
        department: parseInt(formData.budgetHeader?.department) || "",
        docRequired: "Y",
        approvalRequired: formData.budgetHeader?.approvalRequired || "",
        instructions: formData?.instructions || "",
        terms: formData?.termsAndConditions || "",
      },
      lines:
        formData.materialsData?.map((material: any, index: number) => ({
          // budgetId: nanoid(4),
          // budgetLineId: index + 1,
          //   rfqLineId: `RFL${index + 1}`,
          budgetLineName: material.budgetLineName || "",
          budgetValue: parseInt(material.budgetValue.replace(/,/g, "")) || "",
          startDate: material.startDate || "",
          endDate: material.endDate || "",
          bom: material.bom || "",
          allocation: material.allocation || null,
          lineDescription: material.lineDescription || "",
          currencyCode: "INR",
          bomLines: material.bomLines?.map((bomLine: any, index: number) => ({
            // bomId: index + 1,
            categoryId: Number(bomLine.categoryId) || "",
            categoryName: bomLine.categoryName || "",
            materialId: bomLine.materialId || "",
            materialName: bomLine.materialName || "",
            quantity: Number(bomLine.quantity) || "",
            uomId: Number(bomLine.uomId) || "",
            uomName: bomLine.uomName || "",
            allocated: Number(bomLine.allocated.replace(/,/g, "")) || "",
          })),
        })) || [],
      // requiredDocs:
      //   formData.budgetHeader?.requiredDocs?.map((doc: any, index: number) => ({
      //     documentName: doc.documentName || "",
      //     mandatory: doc.mandatory || 0,
      //   })) || [],
      approvals: formattedApprovalData || [],
      // additionalData: {
      //   termsAndConditions: formData?.termsAndConditions || "",
      //   instructions: formData?.instructions || "",
      // },
    };

    // // Append attachments to docKeys

    console.log(JSON.stringify(submissionData));

    // Create FormData object
    const formDataToSend = new FormData();
    formDataToSend.append("header", JSON.stringify(submissionData.header));
    formDataToSend.append("lines", JSON.stringify(submissionData.lines));
    formDataToSend.append(
      "approvals",
      JSON.stringify(submissionData.approvals)
    );
    // formDataToSend.append(
    //   "additionalData",
    //   JSON.stringify(submissionData.additionalData)
    // );

    // Append files to FormData
    // let fileIndex = 0;
    // formData.docKeys.fileList.forEach((doc: any) => {
    //   // console.log("doc",doc,formData)
    //   if (doc.originFileObj) {
    //     console.log("doccc",doc)
    //     formDataToSend.append(`files[${fileIndex}]`, doc.originFileObj, doc.name);
    //     fileIndex++;
    //   }
    // });

    let _filesData: any = [];

    formData.docKeys?.fileList?.forEach((attachment: any, index: number) => {
      if (!attachment) {
        return;
      }
      const file = attachment?.originFileObj;
      formDataToSend.append(`files`, file);
      _filesData.push({
        fileIndex: index,
        module: "Budget",
        moduleFileType: "Special Instructions",
        level: "HEADER_LEVEL",
      });
    });

    if (formData?.instructions) {
      _filesData.push({
        fileIndex: _filesData.length + 0,
        module: "Budget",
        moduleFileType: "instructions",
        level: "HEADER_LEVEL",
      });
      console.log("090999429", JSON.stringify(formData));
    }

    if (formData?.termsAndConditions) {
      _filesData.push({
        fileIndex: _filesData.length + 0,
        module: "Budget",
        moduleFileType: "termsAndConditions",
        level: "HEADER_LEVEL",
      });
      console.log("090999429", JSON.stringify(formData));
    }

    formDataToSend.append("docKeys", JSON.stringify(_filesData));

    if (formData?.instructions) {
      const instructionsFile = new Blob([formData?.instructions], {
        type: "text/html",
      });
      formDataToSend.append(
        `files`,
        new File([instructionsFile], "instructions.html", {
          type: "text/html",
        })
      );
    }

    if (formData?.termsAndConditions) {
      const termsAndConditionsFile = new Blob([formData?.termsAndConditions], {
        type: "text/html",
      });
      formDataToSend.append(
        `files`,
        new File([termsAndConditionsFile], "termsAndConditions.html", {
          type: "text/html",
        })
      );
    }

    BudgetCreation(formDataToSend);

    // formData.attachments?.forEach((attachment: any) => {
    //   if (attachment?.originFileObj) {
    //     formDataToSend.append(
    //       `files[${fileIndex}]`,
    //       attachment?.originFileObj,
    //       attachment.name
    //     );
    //     fileIndex++;
    //   }
    // });

    // Log the formDataToSend for debugging
    // console.log("FormData to send:");
    // for (const [key, value] of Array.from(formDataToSend.entries())) {
    //   if (key.includes("files")) {
    //     console.log(key, value);
    //   } else {
    //     console.log(key, JSON.parse(value as string)); // parsing JSON string back to object for readability
    //   }
    // }

    // try {
    //   // Submit the form data to the API
    //   const response = await axios.post("/api/submit", formDataToSend, {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   });
    //   console.log("Submission response:", response.data);
    // } catch (error) {
    //   console.error("Submission error:", error);
    // }
  };

  const BudgetCreation = async (data: any) => {
    try {
      const dataAPI: any = await budgetApis.budgetCreationMethod(data);
      console.log(dataAPI);
      const { status, message, response } = dataAPI;
      if (status) {
        Swal.fire("Created!", response?.budgetId, "success");
        navigate(`/view-budget`);
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
    }
    setDisableSubmit(false);
  };

  const handleExpand = (expanded: boolean, record: any) => {
    console.log("record", record, expanded);
    if (expanded) {
      // Add the record's key to the expandedRowKeys array
      setExpandedRowKeys((prevKeys) => [...prevKeys, record.key]);
    } else {
      // Remove the record's key from the expandedRowKeys array
      setExpandedRowKeys((prevKeys) =>
        prevKeys.filter((key) => key !== record.key)
      );
    }
  };

  // const approvalTimelineContent = formData?.budgetHeader?.quotationApprovals ? (
  //   <Timeline className="approval-timeline">
  //     {formData.budgetHeader.budgetApprovals.map(
  //       (approval: ApprovalData, index: number) => (
  //         <Timeline.Item key={index}>
  //           {approval.userName}
  //           <div className="designation">{approval.roleName}</div>
  //         </Timeline.Item>
  //       )
  //     )}
  //   </Timeline>
  // ) : null;

  const requiredDocsContent = formData?.budgetHeader?.requiredDocs ? (
    <Table
      dataSource={formData.budgetHeader.requiredDocs.map(
        (doc: any, index: number) => ({
          key: index + 1,
          sNo: index + 1,
          documentName: doc.documentName,
          mandatory: doc.mandatory ? "Yes" : "No",
        })
      )}
      columns={[
        {
          title: "S.No",
          dataIndex: "sNo",
          key: "sNo",
        },
        {
          title: "Document Name",
          dataIndex: "documentName",
          key: "documentName",
        },
        {
          title: "Mandatory to Upload",
          dataIndex: "mandatory",
          key: "mandatory",
        },
      ]}
      pagination={false}
      size="small"
      style={{ minWidth: "200px" }}
    />
  ) : null;

  useEffect(() => {
    console.log("HIIII", formData);
    fetchModuleConfig();
  }, []);

  const columns = [
    {
      title: "Budget Line",
      dataIndex: "budgetLineName",
      key: "budgetLineName",
      fixed: "left" as const,
      width: 120,
    },
    {
      title: "Budget Line Description",
      dataIndex: "lineDescription",
      key: "lineDescription",
      // fixed: 'left' as const,
      width: 200,
    },
    {
      title: "Budget Value",
      dataIndex: "budgetValue",
      key: "budgetValue",
      width: 150,
      // render: (text: any, record: any) => (
      //   <p className="justify-end">{formatCurrency(Number(text), "INR")}</p>
      // ),
    },
    {
      title: "Planned Start Date",
      dataIndex: "startDate",
      key: "startDate",
      width: 200,
      render: (text: any) => dayjs(text).format("DD-MMM-YYYY"),
    },
    {
      title: "Planned End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (text: any) => dayjs(text).format("DD-MMM-YYYY"),
    },
    {
      title: "Bill Of Material (BOM)",
      dataIndex: "bom",
      key: "bom",
    },
    {
      title: "BOM Allocation",
      dataIndex: "allocation",
      key: "allocation",
    },
  ];

  const ApprovalTimelineContent = () => {
    const approvalsData = JSON.parse(formData?.budgetHeader?.approvalsData);
    console.log("approvalsData", approvalsData);
    if (
      !approvalsData ||
      approvalsData?.data?.length === 0 ||
      formData?.budgetHeader?.approvalRequired == "N"
    )
      return <Badge color="outline-danger">No</Badge>;
    return (
      <Popover
        content={
          <Timeline className="approval-timeline">
            {approvalsData?.map((approval: any, index: number) => {
              const Role = roles.find(
                (role: any) => role?.roleID == approval?.roleId
              );
              return (
                <Timeline.Item key={index}>
                  {
                    Role?.employees?.find((e: any) => e?.id == approval?.userId)
                      ?.name
                  }
                  <div className="designation">{Role?.roleName}</div>
                </Timeline.Item>
              );
            })}
          </Timeline>
        }
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <span
          style={{
            color: "#2263b3",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          Yes
        </span>
      </Popover>
    );
  };

  return (
    <div className="content clearfix">
      <AntCollapse defaultActiveKey={["1"]}>
        <Panel header="General Details" key="1">
          <Descriptions title="" className="custom-description-title">
            <Descriptions.Item label="Budget Name">
              {formData?.budgetHeader?.budgetName}
            </Descriptions.Item>
            <Descriptions.Item label="Planned Start Date">
              {dayjs(formData?.budgetHeader?.startDate).format("DD-MMM-YYYY")}
            </Descriptions.Item>
            <Descriptions.Item label="Planned End Date">
              {dayjs(formData?.budgetHeader?.endDate).format("DD-MMM-YYYY")}
            </Descriptions.Item>
            <Descriptions.Item label="Budget Description">
              <Popover
                content={
                  <div>
                    <p>{formData?.budgetHeader?.description}</p>
                  </div>
                }
                title={"Description"}
              >
                {formData?.budgetHeader?.description?.length > 20 ? (
                  <span
                    style={{
                      color: "#2263b3",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    {formData?.budgetHeader?.description?.substring(0, 20)}
                    ...
                  </span>
                ) : (
                  formData?.budgetHeader?.description
                )}
              </Popover>
              {/* {formData?.budgetHeader?.description} */}
            </Descriptions.Item>
            <Descriptions.Item label="Budget for">
              {formData.budgetHeader?.budgetFor}
            </Descriptions.Item>
            <Descriptions.Item label="Site Name">
              {formData.budgetHeader?.siteName}
            </Descriptions.Item>
            <Descriptions.Item label="Contractor Name">
              {formData.budgetHeader?.contractorName}
            </Descriptions.Item>
            <Descriptions.Item label="Line Of Business (LOB)">
              {formData.budgetHeader?.lob}
            </Descriptions.Item>
            <Descriptions.Item label="Cost Center">
              {formData.budgetHeader?.costCenterName}
            </Descriptions.Item>
            <Descriptions.Item label="Department">
              {formData.budgetHeader?.departmentName}
            </Descriptions.Item>
            <Descriptions.Item label="Approvals">
              {/* {formData.budgetHeader?.approvalRequired === "Y" ? (
                <Popover
                  content={approvalTimelineContent}
                  title={
                    <span style={{ color: "#2263b3" }}>Approval Hierarchy</span>
                  }
                >
                  <span
                    style={{
                      color: "#2263b3",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    Yes
                  </span>
                </Popover>
              ) : (
                "No"
              )} */}
              {formData?.budgetHeader?.approvalsData && (
                <ApprovalTimelineContent />
              )}
            </Descriptions.Item>
            {/* <Descriptions.Item label="Additional Charges">
              {" "}
              {formData.budgetHeader?.additionalCharges}
            </Descriptions.Item>
            <Descriptions.Item label="Auto Release">
              {formData.budgetHeader?.autoRelease === "Y" ? "Yes" : "No"}
            </Descriptions.Item> */}
          </Descriptions>
        </Panel>
        <Panel header="Materials" key="2">
          <Table
            columns={columns}
            dataSource={formData.materialsData || []}
            scroll={{ x: "max-content" }}
            expandable={{
              expandedRowRender: (record: any) => {
                if (record.bom == "Y") {
                  return (
                    <div>
                      <div>
                        <p style={{ margin: 0 }}>
                          <strong>BOM Lines</strong>
                        </p>
                        <div className="mt-3">
                          <Table
                            className="customTable"
                            columns={[
                              {
                                title: "Category",
                                dataIndex: "categoryName",
                                key: "categoryName",
                                fixed: "left" as const,
                                width: 130,
                              },
                              {
                                title: "Material Name",
                                dataIndex: "materialName",
                                key: "materialName",
                                fixed: "left" as const,
                                width: 130,
                              },
                              {
                                title: "Qty",
                                dataIndex: "quantity",
                                key: "quantity",
                                fixed: "left" as const,
                                width: 130,
                              },
                              {
                                title: "UOM",
                                dataIndex: "uomName",
                                key: "uomName",
                                width: 130,
                              },
                              {
                                title: "Allocation",
                                dataIndex: "allocated",
                                key: "allocated",
                                width: 130,
                                render: (text: any) => {
                                  if (record.allocation === "value") {
                                    const value = parseFloat(
                                      text.toString().replace(/,/g, "")
                                    );

                                    // Check if the parsed value is a valid number
                                    if (!isNaN(value)) {
                                      // Format the value as currency
                                      return formatCurrency(value, "INR");
                                    } else {
                                      return text; // Return original value if invalid
                                    }
                                  } else {
                                    return text + "%";
                                  }
                                },
                              },
                            ]}
                            dataSource={record.bomLines?.map((item: any) => ({
                              ...item,
                              key: item?.id,
                            }))}
                            scroll={{ x: 1000 }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                }
                return null;
              },
              expandedRowKeys,
              onExpand: handleExpand,
              rowExpandable: (record: any) => record.bom === "Y", // Conditionally show expandable icon
            }}
            bordered
            size="small"
            pagination={false}
            locale={{ emptyText: "No materials added" }}
          />
        </Panel>
        <Panel header="Other Information" key="3">
          <Descriptions title="" className="custom-description-title">
            <Descriptions.Item label="Instructions">
              <span
                style={{
                  color: "#2263b3",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => setInstructionsVisible(true)}
              >
                View Instructions
              </span>
            </Descriptions.Item>
            <Descriptions.Item label="Terms and Conditions">
              <span
                style={{
                  color: "#2263b3",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
                onClick={() => setTermsVisible(true)}
              >
                View Terms and Conditions
              </span>
            </Descriptions.Item>
            {formData.docKeys.fileList?.length > 0 && (
              <Descriptions.Item label="">
                <div>
                  <div className="">
                    Attachments &nbsp;
                    <PaperClipOutlined />
                  </div>
                  <div>
                    {formData.docKeys.fileList?.map(
                      (attachment: any, index: number) => (
                        <div
                          key={index}
                          className="w-100 d-flex justify-content-between"
                        >
                          <div>
                            <strong>{index + 1}.</strong>
                            &nbsp;
                            {attachment.name}
                            &nbsp; &nbsp; &nbsp; &nbsp;
                          </div>
                          <div>
                            <a
                              href={URL.createObjectURL(
                                attachment?.originFileObj
                              )}
                              download={attachment.name}
                              style={{ color: "black", fontSize: "18px" }}
                            >
                              <DownloadOutlined />
                            </a>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </Descriptions.Item>
            )}
          </Descriptions>
        </Panel>
      </AntCollapse>
      <Modal
        title="Instructions"
        visible={instructionsVisible}
        footer={null}
        onCancel={() => setInstructionsVisible(false)}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        {formData?.instructions ? (
          <pre>{formData?.instructions}</pre>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No instructions provided for this Budget" />
          </div>
        )}
        {/* <div
          dangerouslySetInnerHTML={{
            __html: formData?.instructions || "",
          }}
        /> */}
      </Modal>
      <Modal
        title="Terms and Conditions"
        visible={termsVisible}
        footer={null}
        onCancel={() => setTermsVisible(false)}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        {formData?.termsAndConditions ? (
          <pre>{formData?.termsAndConditions}</pre>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No terms and conditions provided for this purchase order" />
          </div>
        )}
      </Modal>
      <div className="actions clearfix">
        <ul>
          <li>
            {disableSubmit ? (
              <Button color="primary" type="button">
                <Spinner size="sm" color="light" />
              </Button>
            ) : (
              <Button color="primary" onClick={handleSubmit}>
                Submit
              </Button>
            )}
          </li>
          <li>
            <Button
              color="secondary"
              onClick={props.prev}
              className="btn-dim btn btn-secondary"
            >
              Previous
            </Button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default React.memo(BudgetPreview);
